// @ts-nocheck
import { getPastHoursByTimestamp } from '@src/helpers/DateHelper';
import { generateInitialsHelper, sanitize } from '@src/helpers/Helpers';
import { parseIntSafely } from '@src/helpers/IntegerHelper';

class ChatModel {
	public waId: string;
	public tags: any[];
	public assignedToUser: any;
	public assignedGroup: any;
	public isHide: boolean;
	public supplierToCreateOrder: boolean;

	constructor(data) {
		const contact = data.contact;
		const lastMessage = data.last_message;
		const contactPayload = contact.waba_payload;
		const lastMessagePayload = lastMessage?.waba_payload;
		const customer = data.customer;

		this.customer = customer;
		this.waId = contactPayload.wa_id;
		this._id = data?._id;

		this.setName(contactPayload?.profile?.companyName || contactPayload?.profile?.name);
		this.setCompanyName(contactPayload.profile.companyName);

		this.newMessages = data.new_messages;

		this.lastReceivedMessageTimestamp = parseIntSafely(contact.last_message_timestamp);

		this.setLastMessage(lastMessagePayload);

		// Use last message timestamp from contact object, if last message does not exist
		this.lastMessageTimestamp = this.lastMessageTimestamp
			? this.lastMessageTimestamp
			: this.lastReceivedMessageTimestamp;

		this.assignedGroup = data.assigned_group;
		this.assignedToUser = data.assigned_to_user;
		this.tags = data.tags;

		// Not need to sanitize this, because it is already sanitized
		// this.sanitize();

		//sudo_work
		this.isHide = data?.isHide;
		this.contact = data?.contact;
		this.supplierToCreateOrder = data?.supplierToCreateOrder;
	}

	sanitize() {
		this.name = sanitize(this.name);
		this.lastMessageBody = sanitize(this.lastMessageBody);
		this.lastMessageButtonText = sanitize(this.lastMessageButtonText);
		this.lastMessageInteractiveButtonText = sanitize(this.lastMessageInteractiveButtonText);
		this.lastMessageCaption = sanitize(this.lastMessageCaption);
	}

	setCompanyName(name) {
		this.companyName = name;
	}

	setName(name) {
		this.name = name;
		this.initials = this.generateInitials();
	}

	generateInitials = () => {
		console.log();
		return generateInitialsHelper(this.name);
	};

	setLastMessage(lastMessagePayload) {
		this.lastMessage = lastMessagePayload;
		this.lastMessageBody = this.lastMessage?.text?.body;
		this.lastMessageButtonText = lastMessagePayload?.button?.text;
		this.lastMessageInteractiveButtonText = lastMessagePayload?.interactive?.button_reply?.title;
		this.lastMessageCaption =
			lastMessagePayload?.image?.caption ??
			lastMessagePayload?.video?.caption ??
			lastMessagePayload?.audio?.caption ??
			lastMessagePayload?.document?.caption;
		this.lastMessageType = lastMessagePayload?.type;
		this.lastMessageTimestamp = parseIntSafely(this.lastMessage?.timestamp);
		this.isLastMessageFromUs = lastMessagePayload?.hasOwnProperty('to');

		if (this.lastMessage?.hasOwnProperty('from')) {
			this.lastReceivedMessageTimestamp = this.lastMessageTimestamp;
		}

		this.isExpired = false || this.checkIfExpired();
	}

	getPastHoursAfterLastMessage() {
		return getPastHoursByTimestamp(this.lastReceivedMessageTimestamp);
	}

	checkIfExpired() {
		return this.getPastHoursAfterLastMessage() >= 24;
	}

	getAssignedUserUsername() {
		return this.assignedToUser?.username;
	}

	generateAssignedToInitials() {
		return this.assignedToUser?.username?.[0]?.toUpperCase();
	}

	generateAssignmentInformation() {
		let info = '';
		if (this.assignedToUser) {
			info = 'Assigned to: ' + this.assignedToUser.username;
		}

		if (this.assignedGroup) {
			if (info) {
				info += ', ';
			}

			info += 'Assigned group: ' + this.assignedGroup.name;
		}

		return info;
	}
}

export default ChatModel;
